import {
  Outlet,
  createRootRouteWithContext,
  redirect,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import { ThemeProvider } from "@/components/theme-provider";
import type { useAuth } from "@/providers/auth";
import { Toaster } from "@/components/ui/sonner";
import type { QueryClient } from "@tanstack/react-query";
import type { useOrg } from "@/providers/organization";

interface RouterContext {
  auth: ReturnType<typeof useAuth>;
  org: ReturnType<typeof useOrg>;
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  beforeLoad: ({ context }) => {
    if (location.pathname === "/") {
      if (context.auth.user.account) {
        const orgs = context.auth.user.account.orgs;

        if (!orgs) {
          throw redirect({ to: "/onboard" });
        } else {
          const currentOrg = context.org.orgId;
          const targetPath = `/${orgs.find((org) => org.id === currentOrg)?.slug ?? orgs[0].slug}/dashboard`;

          if (location.pathname === "/") {
            throw redirect({ to: targetPath });
          }

          return;
        }
      } else {
        throw redirect({
          to: "/auth/login",
        });
      }
    }
    // if (location.pathname === "/") {
    //   throw redirect({
    //     to: "/auth/login",
    //   });
    // }
  },
});

function RootComponent() {
  return (
    <>
      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
        <Toaster richColors position="top-center" />
        <Outlet />
        <TanStackRouterDevtools />
      </ThemeProvider>
    </>
  );
}
